function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffectEvent as $8ae05eaa5c114e9c$export$7f54fc3180508a52 } from "./useEffectEvent.module.js";
import { useLayoutEffect as $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c } from "./useLayoutEffect.module.js";
import { useState as $fCAlL$useState, useRef as $fCAlL$useRef } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
  var _ref = (0, $fCAlL$useState)(defaultValue),
    _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[0],
    setValue = _ref2[1];
  var effect = (0, $fCAlL$useRef)(null);
  // Store the function in a ref so we can always access the current version
  // which has the proper `value` in scope.
  var nextRef = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)(function () {
    if (!effect.current) return;
    // Run the generator to the next yield.
    var newValue = effect.current.next();
    // If the generator is done, reset the effect.
    if (newValue.done) {
      effect.current = null;
      return;
    }
    // If the value is the same as the current value,
    // then continue to the next yield. Otherwise,
    // set the value in state and wait for the next layout effect.
    if (value === newValue.value) nextRef();else setValue(newValue.value);
  });
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    // If there is an effect currently running, continue to the next yield.
    if (effect.current) nextRef();
  });
  var queue = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)(function (fn) {
    effect.current = fn(value);
    nextRef();
  });
  return [value, queue];
}
export { $1dbecbe27a04f9af$export$14d238f342723f25 as useValueEffect };